<template>
  <div>
    <div class="pltext">
      <el-input ref="intentionText" @focus="focusinput" id="input" type="textarea"
        :autosize="{ minRows: 3, maxRows: 10}" :placeholder="inputplaceholder" v-model="textarea">
      </el-input>
      <div class="pltextbottom">
        <img @click="emjiShowHide = !emjiShowHide" style="width: 30px;height: 30px;cursor: pointer;" :src="emjiimgurl"
          alt="">
        <div class="plbtndiv">
          <div v-if="textarea.length!=0">
            <div style="margin-right: 10px;" v-if="textarea.length<=150">{{textarea.length}}</div>
            <div style="color: red;margin-right: 10px;" else>{{textarealengthfc(textarea.length)}}</div>
          </div>
          <el-button :disabled="btndisabled" :loading="plloading" @click="plclick" size="mini" type="primary" round>评论
          </el-button>
        </div>
        <VEmojiPicker class="VEmojiPickerC" style="width: 50%;" v-show="emjiShowHide" @select="selectEmoji" />
      </div>
    </div>
    <div v-if="commentdata.length!=0" class="mainpage">
      <!-- 评论内容 -->
      <div v-for="(item,index) in commentdata" class="pldiv">
        <div class="pltop">
          <div class="pltop-left">
            <img class="plimg" :src="baseUrl.hbjx+'/'+item.user.userHeadUrl" alt="">
          </div>
          <div class="pltop-right">
            <div class="plname">
              <span @click="replyClick(item.id,item.user.id,item.user.userName)">{{item.user.userName}}</span>
              <span @click="zuozheClick" style="cursor: pointer;" v-if="item.author.id==item.user.id"
                class="zuozhe">作者</span>
            </div>
            <div class="plcontent">{{item.contents}}</div>
            <div class="pltime">
              <div class="pltimeleft"><Time :time="item.createTime" /><span
                  @click="replyClick(item.id,item.user.id,item.user.userName)" style="margin-left: 20px;">回复</span>
              </div>
              <div class="pltimeright"></div>
            </div>
          </div>
        </div>
        <!-- 回复内容 -->
        <!-- v-if="index<=showhide" -->
        <div>
          <!-- 第一条回复 -->
          <div v-if="item.replys.length>0" class="plbottom">
            <div class="pltop-left">
              <img class="plimg" :src="baseUrl.hbjx+'/'+item.replys[0].fromUser.userHeadUrl" alt="">
            </div>
            <div class="pltop-right">
              <div class="plnamenew">
                <!-- 评论 -->
                <div style="display: flex;align-items: center;" v-if="item.replys[0].fromUser.id!=item.replys[0].toUser.id">
                  <div>
                    <span
                      @click="replyClick(item.id,item.replys[0].fromUser.id,item.replys[0].fromUser.userName)">{{item.replys[0].fromUser.userName}}</span>
                    <span @click="zuozheClick" style="cursor: pointer;"
                      v-if="item.author.id==item.replys[0].fromUser.id" class="zuozhe">作者</span>
                  </div>
                  <i style="margin: 0px 5px;" class="el-icon-caret-right"></i>
                  <div>
                    <span
                      @click="replyClick(item.id,item.replys[0].toUser.id,item.replys[0].toUser.userName)">{{item.replys[0].toUser.userName}}</span>
                    <span @click="zuozheClick" style="cursor: pointer;" v-if="item.author.id==item.replys[0].toUser.id"
                      class="zuozhe">作者</span>
                  </div>
                </div>
                <!-- 自己回复自己 -->
                <div v-else>
                  <span
                    @click="replyClick(item.id,item.replys[0].fromUser.id,item.replys[0].fromUser.userName)">{{item.replys[0].fromUser.userName}}</span>
                  <span @click="zuozheClick" style="cursor: pointer;"
                    v-if="item.author.id==item.replys[0].fromUser.id" class="zuozhe">作者</span>
                </div>
              </div>
              <div class="plcontent">{{item.replys[0].content}}</div>
              <div class="pltime">
                <div class="pltimeleft"><Time :time="item.replys[0].createTime" /><span
                    @click="replyClick(item.id,item.replys[0].fromUser.id,item.replys[0].fromUser.userName)"
                    style="margin-left: 20px;">回复</span></div>
                <div class="pltimeright"></div>
              </div>
            </div>
          </div>
          <div style="display: none;" ref="circle">
            <div v-for="(reply,indexnew) in item.replys" v-if="indexnew>0" class="plbottom">
              <div class="pltop-left">
                <img class="plimg" :src="baseUrl.hbjx+'/'+reply.fromUser.userHeadUrl" alt="">
              </div>
              <div class="pltop-right">
                <div class="plnamenew">
                  <div style="display: flex;align-items: center;" v-if="reply.fromUser.id!=reply.toUser.id">
                    <div>
                      <span
                        @click="replyClick(item.id,reply.fromUser.id,reply.fromUser.userName)">{{reply.fromUser.userName}}</span>
                      <span @click="zuozheClick" style="cursor: pointer;" v-if="item.author.id==reply.fromUser.id"
                        class="zuozhe">作者</span>
                    </div>
                    <i style="margin: 0px 5px;" class="el-icon-caret-right"></i>
                    <div>
                      <span
                        @click="replyClick(item.id,reply.toUser.id,reply.toUser.userName)">{{reply.toUser.userName}}</span>
                      <span @click="zuozheClick" style="cursor: pointer;" v-if="item.author.id==reply.toUser.id"
                        class="zuozhe">作者</span>
                    </div>
                  </div>
                  <!-- 自己回复自己 -->
                  <div v-else>
                    <span
                      @click="replyClick(item.id,reply.fromUser.id,reply.fromUser.userName)">{{reply.fromUser.userName}}</span>
                    <span @click="zuozheClick" style="cursor: pointer;" v-if="item.author.id==reply.fromUser.id"
                      class="zuozhe">作者</span>
                  </div>
                </div>
                <div class="plcontent">{{reply.content}}</div>
                <div class="pltime">
                  <div class="pltimeleft"><Time :time="reply.createTime" /><span
                      @click="replyClick(item.id,reply.fromUser.id,reply.fromUser.userName)"
                      style="margin-left: 20px;">回复</span></div>
                  <div class="pltimeright"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.replys.length>1" :ref="item.id" @click="openClick(index,item.id,item.replys.length-1)"
            class="opendiv"><span>———</span>展开{{item.replys.length-1}}条回复<i class="el-icon-caret-bottom"></i></div>
        </div>

        <!-- <div v-if="item.replys.length>0 && showhide==0" @click="openClick(item.replys.length)" class="opendiv"><span>———</span>展开{{item.replys.length-1}}条回复<i class="el-icon-caret-bottom"></i></div>
        <div v-if="item.replys.length>0 && showhide!=0" @click="openClick(item.replys.length)" class="opendiv"><span>———</span>收起{{item.replys.length-1}}条回复<i class="el-icon-caret-top"></i></div> -->
      </div>
      <div class="pagination">
        <el-pagination class="pagefy" :total="total" :current-page="pageNumber" :page-size="pageSize"
          :page-sizes="[10, 20, 30, 50]" @current-change="handleCurrentChange" @size-change="handleSizeChange"
          background layout="total, sizes, prev, pager, next"></el-pagination>
      </div>
    </div>
    <div class="topbarnodata" v-else>
      <img src="../../assets/nodata1.png" alt="">
      <div style="margin-top: 20px;font-size: 13px;color: #aca8a8;">空空如也，快去评论吧！</div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { VEmojiPicker } from 'v-emoji-picker'
  export default {
    components: {
      VEmojiPicker
    },
    data() {
      return {
        plloading: false,
        showhide: 0,//是否展示
        textarea: '',//评论内容
        inputplaceholder: '有爱评论，说的好听的~',
        emjiShowHide: false,
        emjiimgurl: require('../../assets/zhayan.png'),
        btndisabled: false,
        commentdata: [],//评论回复数据
        commenttype: '1',//记录是评论还是回复1是评论，2是回复
        commentid: '',//评论的id
        formuserid: '',//被评论的用户id
        total: 0,
        pageNumber: 1,
        pageSize: 10,
      }
    },
    //初始化方法
    mounted() {
      this.getComment();
    },
    watch: {
      'emjiShowHide'(newVal, oldVal) {
        if (newVal) {
          this.emjiimgurl = require('../../assets/zhayanon.png');
        } else {
          this.emjiimgurl = require('../../assets/zhayan.png');
        }
      },
      'textarea'(newVal, oldVal) {
        var num = newVal.length;
        if (num > 150) {
          this.btndisabled = true;
        } else {
          this.btndisabled = false;
        }
      },
      'commentdata'(newVal, oldVal) {
       console.log(newVal);
      },
    },
    methods: {
      //展开按钮点击事件
      openClick(index, itemid, replyslength) {
        if (this.$refs.circle[index].style.display == 'none') {
          this.$refs.circle[index].style.display = 'block'
          this.$refs[itemid][0].innerHTML = '<span data-v-cac0ffa2="">———</span>收起' + replyslength + '条回复<i data-v-cac0ffa2="" class="el-icon-caret-top"></i>'
        } else {
          this.$refs.circle[index].style.display = 'none'
          this.$refs[itemid][0].innerHTML = '<span data-v-cac0ffa2="">———</span>展开' + replyslength + '条回复<i data-v-cac0ffa2="" class="el-icon-caret-bottom"></i>'
        }
      },
      //点击作者按钮
      zuozheClick() {
        this.commenttype = '1';
        this.textarea = "";
        this.inputplaceholder = '有爱评论，说的好听的~';
        this.$nextTick(() => {
          this.$refs.intentionText.focus();
        })
      },
      //回复按钮点击事件
      replyClick(commentid, formuserid, userName) {
        // if (formuserid == JSON.parse(this.baseUrl.getCookie("userInfo")).id) {
        //   this.$Message.error('自己不能回复自己！');
        //   return;
        // }
        this.inputplaceholder = "@" + userName;
        this.commentid = commentid;
        this.formuserid = formuserid;
        this.commenttype = '2'//1是评论，2是回复
        this.$nextTick(() => {
          this.$refs.intentionText.focus();
        })
      },
      //获取评论数据
      getComment() {
        this.$showLoading();
        axios.get(this.baseUrl.hbjx + '/commentMD/queryByContributionId', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            contributionId: this.$route.query.manuscriptId,
            pageSize: this.pageSize,
            pageNum: this.pageNumber,
          }
        })
          .then((res) => {
            this.commentdata = res.data.list;
            this.total = res.data.count;
            this.$closeLoading();
          })
          .catch(function (err) {
            this.$closeLoading();
            console.log(err);

          });
      },
      //新增一条评论
      saveComment() {
        this.plloading = true;
        let params = new FormData(); // 创建form对象
        params.append("userId", JSON.parse(this.baseUrl.getCookie("userInfo")).id); // 用户id
        params.append("contributionId", this.$route.query.manuscriptId); //稿件id
        params.append("contents", this.textarea); //评论内容
        params.append("isPublish", '1'); //是否公开
        axios.post(this.baseUrl.hbjx + "/commentMD/saveComment", params).then((res) => {
          if (res.data.code == '200') {
            this.commenttype = '1'//1是评论，2是回复
            this.textarea = "";
            this.emjiShowHide = false;
            this.inputplaceholder = '有爱评论，说的好听的~';
            this.getComment();
            this.plloading = false;
            this.$Message.success('评论发表成功！');
          } else {
            this.plloading = false;
            this.$Message.error('评论发表失败！');
          }

        });
      },
      //新增一条回复
      saveReply() {
        this.plloading = true;
        let params = new FormData(); // 创建form对象
        params.append("fromUserId", JSON.parse(this.baseUrl.getCookie("userInfo")).id); //回复人的用户id
        params.append("toUserId", this.formuserid); //被回复的人的用户id
        params.append("commentId", this.commentid); //评论id
        params.append("content", this.textarea); //回复内容
        params.append("isPublish", '1'); //是否公开
        axios.post(this.baseUrl.hbjx + "/commentMD/saveReply", params).then((res) => {
          if (res.data.code == '200') {
            this.commenttype = '1'//1是评论，2是回复
            this.textarea = "";
            this.emjiShowHide = false;
            this.inputplaceholder = '有爱评论，说的好听的~';
            this.getComment();
            this.plloading = false;
            this.$Message.success('回复成功！');
          } else {
            this.plloading = false;
            this.$Message.success('回复失败！');
          }

        });
      },
      //评论按钮点击事件
      plclick() {
        var cookie = this.baseUrl.getCookie("userInfo");
        if (cookie=="") {
          this.$Message.error('登录后才可以发表评论！');
          return;
        }
        if (!this.textarea) {
          this.$Message.error('评论内容不能为空！');
          return;
        }
        //评论操作
        if (this.commenttype == '1') {
          this.saveComment();
        }
        //回复操作
        else if (this.commenttype == '2') {
          this.saveReply();
        } else {
          this.$Message.error('操作失败！');
        }
      },
      //获取焦点事件
      focusinput() {
        this.emjiShowHide = true;
      },
      textarealengthfc(val) {
        if (val > 150) {
          return parseInt(150 - val)
        }
      },
      //表情选择事件
      selectEmoji(emoji) {// 选择emoji后调用的函数
        let input = document.getElementById("input")
        let startPos = input.selectionStart
        let endPos = input.selectionEnd
        let resultText = input.value.substring(0, startPos) + emoji.data + input.value.substring(endPos)
        input.value = resultText
        input.focus()
        input.selectionStart = startPos + emoji.data.length
        input.selectionEnd = startPos + emoji.data.length
        this.textarea = resultText
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getComment();
      },
      handleCurrentChange(val) {
        this.pageNumber = val;
        this.getComment();
      },
    }
  }
</script>
<style scoped>
  .opendiv {
    margin-left: 90px;
    margin-top: 10px;
    margin-bottom: 15px;
    cursor: pointer;
    font-size: 12px;
  }

  .opendiv span {
    color: rgb(237, 236, 238);
  }

  .topbarnodata {
    width: 100%;
    min-height: 600px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .pagination {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    border-top: 1px solid rgb(237, 236, 238);
  }

  .zuozhe {
    background-color: red;
    padding: 2px 5px;
    border-radius: 3px;
    color: white;
    font-size: 10px;
    margin-left: 5px;
  }

  .plbtndiv {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .VEmojiPickerC {
    position: absolute;
    left: 0px;
    top: 50px;
  }

  /deep/ .el-textarea__inner {
    background-color: rgb(237, 236, 238);
    ;
    border: none;
  }

  /deep/ .el-textarea__inner:focus {
    background-color: white;
    border: 1.5px solid #6395f0;
  }

  .pltext {
    display: flex;
    min-height: 120px;
    flex-direction: column;
  }

  .pltextbottom {
    display: flex;
    height: 50px;
    width: 100;
    border-bottom: 1px solid rgb(237, 236, 238);
    align-items: center;
    position: relative;
  }

  .plname {
    font-size: 13px;
    color: rgb(63, 62, 62);
    /* color: #6395f0; */
    font-weight: 500;
    cursor: pointer;
  }

  .plnamenew {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: rgb(63, 62, 62);
    /* color: #6395f0; */
    font-weight: 500;
    cursor: pointer;
  }

  .plcontent {
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;
    color: black;
  }

  .pltime {
    font-size: 12px;
    color: rgb(63, 62, 62);
    cursor: pointer;
    display: flex;
  }

  .pltimeleft {
    flex: 1;
  }

  .pltimeright {
    flex: 1;
    text-align: right;
  }

  .plimg {
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }

  .pltop-left {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pltop-right {
    min-height: 60px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
  }

  /* .pltop-right:hover {
    background-color: rgb(237, 236, 238);
  } */

  .plbottom {
    width: 100%;
    flex: 1;
    display: flex;
    padding-left: 60px;
    margin-top: 10px;
  }

  .pltop {
    width: 100%;
    min-height: 60px;
    display: flex;
    margin-top: 10px;
  }

  .pldiv {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .mainpage {
    min-height: 600px;
    padding-left: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/CommentReply/CommentReply.vue